// extracted by mini-css-extract-plugin
export var container = "_5s-0";